module.exports = __webpack_public_path__ + "static/media/background2.253c7772.jpg";